<!--
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2021-01-06 10:21:06
 * @LastEditTime: 2021-01-06 16:49:58
-->
<template>
  <div>
    <div style="height:17px"></div>
    <div class="problem" v-for="(item,index) in listSource" :key="index">
      <div class="title">{{item.title}}</div>
      <div class="content">
        {{item.content}}
      </div>
    </div>
  </div>
</template>
<script>
import {commonQuestion} from '@api/public'
export default {
  name: "problem",
  data() {
    return {
      listSource:[]
    };
  },
  methods: {
    getList(){
      commonQuestion().then(res=>{
        this.listSource = res.data.data;
      })
    }
  },
  mounted() {
    this.getList()
  },
};
</script>
<style scoped>
.problem {
  background: #ffffff;
  padding: 0 11px;
  margin-bottom: 3px;
}
.problem .title {
  font-size: 15px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 600;
  text-align: left;
  color: #333333;
  padding: 17px 0 5px 0;
}
.problem .content {
  font-size: 13px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #999999;
  padding-bottom: 16px;
  word-break: break-alld;
}
</style>
